
import { defineComponent } from 'vue';
import CavuButton from '../cavu-button/cavu-button.vue';
import IconAlert from '@white-label-icon/icon-alert';

export default defineComponent({
  name: 'GuestHint',
  components: { IconAlert, CavuButton },
});
